/* ES: ES-style mobile menu accordion
   - Vanilla JS (no dependency)
   - Supports nested accordions
   - Smooth open/close using height transition
*/
(function () {
  "use strict";

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function openPanel(panel) {
    if (!panel) return;
    panel.hidden = false;
    // reset to measure
    panel.style.height = "0px";
    // force reflow
    panel.offsetHeight;
    var h = panel.scrollHeight;
    panel.style.height = h + "px";
    var onEnd = function (e) {
      if (e.propertyName !== "height") return;
      panel.style.height = "auto";
      panel.removeEventListener("transitionend", onEnd);
    };
    panel.addEventListener("transitionend", onEnd);
  }

  function closePanel(panel) {
    if (!panel) return;
    // if auto height, set to pixel for transition
    var h = panel.scrollHeight;
    panel.style.height = h + "px";
    panel.offsetHeight;
    panel.style.height = "0px";
    var onEnd = function (e) {
      if (e.propertyName !== "height") return;
      panel.hidden = true;
      panel.style.height = "";
      panel.removeEventListener("transitionend", onEnd);
    };
    panel.addEventListener("transitionend", onEnd);
  }

  function setExpanded(btn, expanded) {
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    var item = btn.closest(".es-acc-item, .es-sub-acc-item");
    if (!item) return;

    // micro-animation helper classes (chevron "snap" like ES)
    if (expanded) {
      item.classList.add("is-opening");
      item.classList.remove("is-closing");
      item.classList.add("is-open");
      window.setTimeout(function () {
        item.classList.remove("is-opening");
      }, 260);
    } else {
      if (item.classList.contains("is-open")) {
        item.classList.add("is-closing");
        item.classList.remove("is-opening");
        window.setTimeout(function () {
          item.classList.remove("is-closing");
        }, 260);
      }
      item.classList.remove("is-open");
    }
  }

  function closeOtherOpen(root, keepItem) {
    qsa(root, ".es-acc-item.is-open > .es-acc-trigger, .es-sub-acc-item.is-open > .es-sub-trigger").forEach(function (btn) {
      var item = btn.closest(".es-acc-item, .es-sub-acc-item");
      if (!item || item === keepItem) return;
      var panel = item.querySelector(".es-acc-panel, .es-sub-panel");
      setExpanded(btn, false);
      closePanel(panel);
    });
  }

  function toggle(btn, panelSel, itemSel, root, singleOpen) {
    var item = btn.closest(itemSel);
    if (!item) return;
    var panel = item.querySelector(panelSel);
    var isOpen = btn.getAttribute("aria-expanded") === "true";

    if (singleOpen && root) closeOtherOpen(root, item);

    if (isOpen) {
      setExpanded(btn, false);
      closePanel(panel);
    } else {
      setExpanded(btn, true);
      openPanel(panel);
    }
  }

  document.addEventListener("click", function (e) {
    var topBtn = e.target.closest(".es-acc-trigger");
    if (topBtn) {
      e.preventDefault();
      var root = topBtn.closest("#esMobileMenuAcc") || document;
      toggle(topBtn, ".es-acc-panel", ".es-acc-item", root, true);
      return;
    }

    var subBtn = e.target.closest(".es-sub-trigger");
    if (subBtn) {
      e.preventDefault();
      // allow multiple nested opens inside the same top-level panel
      var root2 = subBtn.closest(".es-acc-panel") || document;
      toggle(subBtn, ".es-sub-panel", ".es-sub-acc-item", root2, false);
      return;
    }
  });

  // When the mobile menu is opened, make sure panels are collapsed (prevents weird states on back/forward cache)
  document.addEventListener("DOMContentLoaded", function () {
    qsa(document, "#esMobileMenuAcc .es-acc-panel, #esMobileMenuAcc .es-sub-panel").forEach(function (p) {
      p.hidden = true;
      p.style.height = "";
    });
    qsa(document, "#esMobileMenuAcc .es-acc-trigger, #esMobileMenuAcc .es-sub-trigger").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
    });
    qsa(document, "#esMobileMenuAcc .es-acc-item, #esMobileMenuAcc .es-sub-acc-item").forEach(function (it) {
      it.classList.remove("is-open","is-opening","is-closing");
    });
  });
})();
